import toast from 'react-hot-toast';
import { logger } from '@/shared/utils/logger';
import { isNativeApp } from '@/shared/utils/nativeBridge';
import { saveBlobWithAnchor } from './anchorDownload';
import { PREPARE_FILE_ERROR_MESSAGE } from './messages';

type DownloadBlobInput = {
  blob: Blob;
  fileName: string;
};

/**
 * Saves a file the browser holds in memory (a fetched document, a generated image)
 * as a blob link from the current tab.
 *
 * Browser only. Inside the native app a `blob:` link can't be saved (iOS strands the
 * WebView on it, Android ignores it) and there is nowhere to send the bytes, so a
 * file that can be downloaded in the app goes through `downloadServerFile`. A call
 * that still reaches this in the app shows an error toast and navigates nowhere.
 *
 * Resolves to whether the file was saved. It never throws, so callers can `await` it
 * for their own pending state and check the result before announcing success.
 */
export const downloadBlob = async ({ blob, fileName }: DownloadBlobInput): Promise<boolean> => {
  if (isNativeApp()) {
    logger.error('native_blob_download', new Error('blob_download_in_native'), { file_name: fileName });
    toast.error(PREPARE_FILE_ERROR_MESSAGE);
    return false;
  }
  saveBlobWithAnchor(blob, fileName);
  return true;
};
